var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMale = function SvgMale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.375 4h-2.95a.63.63 0 0 0-.625.625.63.63 0 0 0 .625.625h1.433l-3.1 3.1c-1.958-1.517-4.791-1.4-6.583.4a4.975 4.975 0 0 0-1.467 3.533 4.94 4.94 0 0 0 1.467 3.534 4.975 4.975 0 0 0 3.533 1.466 4.94 4.94 0 0 0 3.534-1.466c1.8-1.8 1.916-4.625.4-6.584l3.1-3.1v1.434a.63.63 0 0 0 .625.625.63.63 0 0 0 .625-.625v-2.95a.63.63 0 0 0-.625-.625l.008.008Zm-5.008 10.933a3.726 3.726 0 0 1-2.65 1.1c-1 0-1.942-.391-2.65-1.1a3.726 3.726 0 0 1-1.1-2.65c0-1 .391-1.941 1.1-2.65a3.799 3.799 0 0 1 2.65-1.1c.958 0 1.916.367 2.65 1.1a3.757 3.757 0 0 1 0 5.3Z",
    fill: "current"
  })));
};
export default SvgMale;